import { Text, Badge, Box } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';
import { formatSimpleValue } from '../utils/fieldFormatting';
import ValidationBadge from './ValidationBadge';

interface AnnualDrivingDistanceCardProps {
  data?: any;
}

const AnnualDrivingDistanceCard = ({
  data,
}: AnnualDrivingDistanceCardProps) => {
  const colors = useBinderCardColors();

  // Get processed vehicles data
  const vehicles = data?.vehicles || [];

  const formatAnnualDistance = (distance: any) => {
    // Convert to number if it's a string
    const numValue =
      typeof distance === 'string' ? parseFloat(distance) : distance;

    if (
      isNaN(numValue) ||
      numValue === null ||
      numValue === undefined ||
      numValue === 0
    ) {
      return (
        <Badge colorScheme="gray" variant="outline" fontSize="xs">
          Not specified
        </Badge>
      );
    }

    return (
      <Text color={colors.valueColor} fontSize="sm" fontWeight="medium">
        {numValue.toLocaleString()} km
      </Text>
    );
  };

  // Create table rows from processed vehicle data
  const vehicleRows = vehicles.map((vehicle: any) => {
    return [
      vehicle.name,
      formatAnnualDistance(vehicle.annualDistance),
      vehicle.remarks ? (
        <Text fontSize="sm">{formatSimpleValue(vehicle.remarks)}</Text>
      ) : (
        <Text fontSize="xs" color="gray.500" fontStyle="italic">
          No remarks
        </Text>
      ),
      <ValidationBadge status={vehicle.isValid ? 'pass' : 'caution'} />,
    ];
  });

  const headers = ['Vehicle', 'Annual Driving Distance', 'Remarks', 'Outcome'];

  // Handle empty state
  if (vehicleRows.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No vehicle data available
        </Text>
      </Box>
    );
  }

  return (
    <DataTableCard
      description="Check to confirm that annual driving distance is not underreported."
      headers={headers}
      rows={vehicleRows}
    />
  );
};

export default AnnualDrivingDistanceCard;
